"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDisplayFormDropdownButton = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.AttributeDisplayFormDropdownButton = function (_a) {
    var title = _a.title, isOpened = _a.isOpened, toggleDropdown = _a.toggleDropdown;
    var buttonClassNames = classnames_1.default("gd-button-primary", "gd-button-small", "button-dropdown", "dropdown-button", "attribute-display-form-button", "s-attribute-display-form-button", {
        "is-active": isOpened,
    });
    var iconRight = isOpened ? "gd-icon-navigateup" : "gd-icon-navigatedown";
    return (react_1.default.createElement(sdk_ui_kit_1.Button, { className: buttonClassNames, title: title, value: title, onClick: toggleDropdown, iconRight: iconRight }));
};
//# sourceMappingURL=AttributeDisplayFormDropdownButton.js.map